import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';

// Initialize Sentry if it is enabled in the environment.
if (environment && environment.sentry && environment.sentry.dsn) {
  // console.log('Initialize Sentry');
  // Sentry Config: https://docs.sentry.io/platforms/javascript/guides/angular
  Sentry.init(environment.sentry);
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

window.onload = () => {
  // based on https://stackoverflow.com/questions/48719745/displaying-an-alert-for-all-mobile-devices
  // display alert when using a mobile browser
  const mobile = /iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase());
  if (mobile) {
    // alert('This website does not support mobile browsers! Switch to desktop mode for better compatibility');
  } else {
    const version = Number(detectIE());
    if (version >= 12 && version <= 15) {
      alert(
        'This website does not support Microsoft EDGE version 12 to 15! Update to a more recent version for better compatibility'
      );
    }
  }
};

// based on https://codepen.io/gapcode/pen/vEJNZN
// detect if the browser is Internet Explorer, Microsoft Edge or another browser + version
function detectIE() {
  const ua = window.navigator.userAgent;

  const msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  const trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    const rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  const edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}
